var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaidPlanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 9.33333L7 23.3333H21L23.3333 9.33333M4.66667 9.33333L6.66895 10.9352C7.97087 11.9767 8.62184 12.4975 9.27799 12.5783C9.85285 12.6491 10.4335 12.5036 10.907 12.17C11.4475 11.7893 11.7758 11.023 12.4326 9.49055L14 5.83333M4.66667 9.33333C5.311 9.33333 5.83333 8.811 5.83333 8.16667C5.83333 7.52233 5.311 7 4.66667 7C4.02233 7 3.5 7.52233 3.5 8.16667C3.5 8.811 4.02233 9.33333 4.66667 9.33333ZM23.3333 9.33333L21.331 10.9352C20.0291 11.9767 19.3782 12.4975 18.722 12.5783C18.1472 12.6491 17.5665 12.5036 17.093 12.17C16.5525 11.7893 16.2241 11.023 15.5674 9.49055L14 5.83333M23.3333 9.33333C23.9777 9.33333 24.5 8.811 24.5 8.16667C24.5 7.52233 23.9777 7 23.3333 7C22.689 7 22.1667 7.52233 22.1667 8.16667C22.1667 8.811 22.689 9.33333 23.3333 9.33333ZM14 5.83333C14.6443 5.83333 15.1667 5.311 15.1667 4.66667C15.1667 4.02233 14.6443 3.5 14 3.5C13.3557 3.5 12.8333 4.02233 12.8333 4.66667C12.8333 5.311 13.3557 5.83333 14 5.83333ZM14 4.66667H14.0117M23.3333 8.16667H23.345M4.66667 8.16667H4.67833",
    stroke: "#8E97CD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaidPlanIcon);
export default __webpack_public_path__ + "static/media/paidPlanIcon.2a1bb46e322e210de2feaebbc2b27655.svg";
export { ForwardRef as ReactComponent };